module.exports = __webpack_public_path__ + "img/CellCycle-BRCA_10X_Section2.1a55196c.png";